export const REPLY_SUGGESTIONS_FEEDBACK_URL =
  "https://a.sprig.com/YUQyOHFhMWhzMkJGfnNpZDpmMjQyODYzNC0xMDA3LTRlYzItOWE4NC0xMGUwNWUwMjdlNTE=";
